export default __webpack_public_path__ + "static/media/totalEntry.79969cc9.svg";